/*
  Mobile sticky add-to-cart bar.

  It owns no state: the button submits the real product form through its form
  attribute, and the label and price are mirrored from the buy box so variant
  changes and kit selections stay in sync without a second source of truth.
*/
class StickyAtc extends HTMLElement {
  connectedCallback() {
    if (this.initialised) return;
    this.initialised = true;

    this.source = document.querySelector(this.dataset.observe);
    if (!this.source) return;

    this.sourceButton = this.source.querySelector('button[name="add"]');
    this.sourcePrice = this.source.querySelector('.button-price-wrapper');
    this.price = this.querySelector('[data-sticky-price]');
    this.label = this.querySelector('[data-sticky-label]');
    this.button = this.querySelector('button[name="add"]');

    this.sync();

    this.mutationObserver = new MutationObserver(() => this.sync());
    this.mutationObserver.observe(this.source, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
    });

    this.intersectionObserver = new IntersectionObserver(
      ([entry]) => this.classList.toggle('sticky-atc--visible', !entry.isIntersecting),
      { threshold: 0 }
    );
    this.intersectionObserver.observe(this.source);
  }

  disconnectedCallback() {
    this.mutationObserver?.disconnect();
    this.intersectionObserver?.disconnect();
  }

  sync() {
    if (this.sourcePrice && this.price) this.price.innerHTML = this.sourcePrice.innerHTML;

    const sourceLabel = this.sourceButton?.querySelector('.product-form__submit-text');
    if (sourceLabel && this.label) this.label.textContent = sourceLabel.textContent.trim();

    if (this.sourceButton && this.button) {
      this.button.disabled = this.sourceButton.disabled;
      this.button.toggleAttribute('aria-disabled', this.sourceButton.getAttribute('aria-disabled') === 'true');
    }
  }
}

customElements.get('sticky-atc') || customElements.define('sticky-atc', StickyAtc);
